import * as React from "react";
const IconViewMore = (props) => (
  <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.54883 1.61963L9.99996 8.38053L18.4511 1.61963"
      stroke="#1C1C2C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconViewMore;
